import { useMutation, useQueryClient } from '@tanstack/react-query';
import { parsePath, useNavigate, useSearchParams } from 'react-router';

import { SearchParamKeys } from '~/constants/url';
import { routes } from '~/providers/RouterProvider/router.routes';

import { apiResourceSchema } from '../common/schemas';
import { fetchJson } from '../fetch';
import { userSchema } from '../user/schemas';
import { userQueryOptions } from '../user/useUser';

type Payload = {
  emailAddress: string;
  password: string;
  token: string;
};

export const useResetPassword = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useMutation({
    mutationFn: async (body: Payload) => {
      const response = await fetchJson('/authentication/reset-password', {
        method: 'POST',
        schema: apiResourceSchema(userSchema),
        body,
      });

      return response.data;
    },
    onSuccess: (user) => {
      queryClient.clear(); // Clear the cache of whoever was signed in before.
      queryClient.setQueryData(userQueryOptions.queryKey, user);

      const to = parsePath(searchParams.get(SearchParamKeys.REDIRECT_PATH) ?? routes.dashboard);
      navigate(to, { replace: true });
    },
  });
};
